export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  let contents = JSON.parse(payload.contents)
  let currentContents = JSON.parse(newState.pageDataUi[newState.index].contents)
  let newContents = {...currentContents, ...contents}
  payload.contents = JSON.stringify(newContents)
  
  payload.sort = Math.max.apply(Math, newState.pageDataUi.map(function(o) { return o.sort; })) + 1
  newState.pageDataUi[newState.index] = payload;

  newState.pageDataUi = [...newState.pageDataUi]

  return newState;
};
